<style scoped>
.expand-row {
  margin-bottom: 16px;
}
</style>
<template>
  <div>
    <Row class="expand-row">
      <Table :columns="columns8" :data="row.arr"> </Table>
      <!-- <Col span="8">
        <span class="expand-key">Job: </span>
        <span class="expand-value">{{ row.xbid }}</span>
      </Col>
      <Col span="8">
        <span class="expand-key">Interest: </span>
        <span class="expand-value">{{ row.xbsort }}</span>
      </Col> -->
    </Row>
  </div>
</template>
<script>
export default {
  props: {
    row: Object,
  },
  data() {
    return {
      columns8: [
        {
          title: "小板id",
          key: "machineid",
        },
        {
          title: "座位号",
          key: "sort",
        },
        {
          title: "识别小板号",
          key: "videomachineid",
        },
        // {
        //   title: "一个彩票等于多少币",
        //   key: "piaonum",
        // },
        {
          title: "操作",
          key: "action",
          width: 240,
          align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.$emit("triggerReturnOrder", [params.row]);
                    },
                  },
                },
                "游戏记录"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.$emit("triggerDelete", [params.row]);
                    },
                  },
                },
                "删除"
              ),
            ]);
          },
        },
      ],
    };
  },
};
</script>
